import React from "react";
import ReactApexChart from "react-apexcharts";

const UserActivityChart = ({ data }) => {
  if (!data) return null;

  const series = [
    {
      name: "Users",
      data: [
        data.planPurchasedUsersCount,
        data.contestPlayedUsersCount,
      ],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 300,
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 900,
      },
    },
    colors: ["#22c55e"],
    plotOptions: {
      bar: {
        borderRadius: 8,
        columnWidth: "20%",
        distributed: true,
      },
    },
    xaxis: {
      categories: [
        "Plan Purchased",
        "Contest Played",
      ],
    },
    dataLabels: {
      enabled: true,
    },
  };

  return (
    <div className="bg-white p-4 rounded-xl shadow">
      <h2 className="text-lg font-semibold mb-3">User Activity</h2>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={300}
      />
    </div>
  );
};

export default UserActivityChart;